/* External */
import { memo } from 'react';

/* Ott-common */
import { useLiveDuration, useLiveProgress } from '@dtvgo/player-utils-react';

/* Components */
import RemainingTime from './RemainingTime';

function LiveRemainingTime() {
  return <RemainingTime progress={useLiveProgress()} duration={useLiveDuration()} />;
}

export default memo(LiveRemainingTime);
